export let data = [
  {
    id: "1",
    title: "Testimony Prep",
    navOptions: ["4", "5", "6", "7"]
  },
  {
    id: "6",
    title: "Today",
    navOptions: ["6a", "6b", "6c"]
  },
  {
    id: "5",
    title: "Two days away",
    navOptions: ["4a", "4b", "4c", "5a", "5b", "5c", "5e"]
  },
  {
    id: "4",
    title: "Over one week away",
    navOptions: ["4a", "4b", "4c"]
  },
  {
    id: "4a",
    title: "Review your report",
    navOptions: [],
    content: [
      {
        text: "Review your report/documentation",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text:
                "When on the stand, expect report or documentation questions about:"
            },
            {
              list: [
                { text: "Mistakes" },
                { text: "Omissions" },
                { text: "Insufficient details" },
                { text: "Oversights in law enforcement process or procedure" }
              ]
            }
          ]
        }
      },
      {
        text: "Review other material",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text: "Depending on the case and your role, review:"
            },
            {
              list: [
                { text: "Documentation" },
                { text: "Field notes" },
                { text: "Prior testimony" },
                { text: "Body-worn camera footage" },
                { text: "Reports from other agencies at the scene" }
              ]
            }
          ]
        }
      },
      {
        text: "Handle deficiencies in your report",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text:
                "If you identify deficiencies in your report or other case materials, you should:"
            },
            {
              list: [
                {
                  text:
                    "Anticipate questions you might receive about any deficiencies and prepare, and possibly practice, your answers."
                },
                {
                  text:
                    "If a deficiency is significant, discuss it with the DA before you take the stand."
                }
              ]
            }
          ]
        }
      },
      {
        explanation: {
          text: "Other tips",
          popOver: [
            {
              text: "Review materials critically"
            },
            {
              list: [
                {
                  text:
                    "Don't just read your report – review it critically for issues or areas that could be interpreted in different ways to best prepare for questions."
                }
              ]
            },
            {
              text: "Annotate your report"
            },
            {
              list: [
                {
                  text:
                    "If the case is large or complex, it might help to highlight key facts in your report to help you find information quickly."
                }
              ]
            }
          ]
        }
      }
    ]
  },

  {
    id: "4b",
    title: "Talk with the DA",
    navOptions: [],
    content: [
      {
        text: "Discuss the case with the DA",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text: "To secure a meeting with the DA:"
            },
            {
              list: [
                {
                  text:
                    "Contact the DA before the trial to review his/her plan."
                },
                {
                  text:
                    "Or arrive early to the courthouse to set up the discussion."
                }
              ]
            }
          ]
        }
      },
      {
        text: "Ask questions",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text: "Two helpful questions to ask the DA:"
            },
            {
              list: [
                { text: "What are you going to ask me?" },
                { text: "What do you think the defense is likely to ask me?" }
              ]
            },
            {
              text: "Optional Questions"
            },
            {
              list: [
                {
                  text:
                    "I found some issues in my report/documentation (or prior testimony). How should we handle them?"
                },
                { text: "Is there anything I am not allowed to talk about?" },
                { text: "What should I expect from the defense attorney?" }
              ]
            }
          ]
        }
      },
      {
        explanation: {
          text: "Another tip",
          popOver: [
            {
              text: "Build a relationship with the DA."
            },
            {
              text:
                "If you have relationship with the DA, he or she is much more likely to make you a priority."
            }
          ]
        }
      }
    ]
  },
  {
    id: "4c",
    title: "Reduce stress",
    navOptions: [],
    content: [
      {
        text: "Lower stress before testifying",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text:
                "Take time for self-care to help reduce stress. These might help:"
            },
            {
              list: [
                {
                  text:
                    "Visit the courtroom before you testify. (For first timers)"
                },
                { text: "Schedule time to prepare." },
                { text: "Talk with the DA." },
                { text: 'Remind yourself "I am here to help."' },
                { text: "Generally, find ways to healthily re-energize." }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "5a",
    title: "Review how to act",
    navOptions: [],
    content: [
      {
        text: "Check your non-verbal behaviors",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text:
                "To gain credibility with the jury and testify effectively, you should:"
            },
            {
              list: [
                {
                  text: "Avoid fidgeting",
                  how: "Fold your hands in your lap."
                },
                {
                  text: "Maintain an open, attentive posture",
                  how: "Sit toward the front of your chair."
                },
                {
                  text: "Keep eye contact with the attorneys and jury",
                  how:
                    "For short answers, look at the attorney. For long answers, look at the jury."
                },
                {
                  text: "Remain calm under cross-examination",
                  how:
                    "Take deep breaths, pause before answering, and remember it's not personal."
                }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "5b",
    title: "Review how to speak",
    navOptions: [],
    content: [
      {
        text: "Think about your verbal behaviors",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text:
                "To gain credibility with the jury and testify effectively use these verbal behaviors:"
            },
            {
              list: [
                {
                  text: "Use plain language",
                  how:
                    "Refrain from using cop jargon. Most of the jury won't understand law enforcement terminology."
                },
                {
                  text: "Speak clearly",
                  how:
                    "Enunciate. And to help you project your voice, speak to the most distant person in the room."
                },
                {
                  text: "Answer questions confidently",
                  how:
                    "Practice your answers; Anticipate questions you may be asked."
                },
                {
                  text: "Address all parties with equal respect",
                  how:
                    "Use ma'am or sir and the same respectful demeanor for all parties in the process."
                },
                {
                  text: "Explain answers in an organized way",
                  how:
                    "Listen carefully while you receive the question and say your answers accordingly."
                }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "5c",
    title: "Review what to say",
    navOptions: [],
    content: [
      {
        text: "Review response quality",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text: "To gain credibility with the jury and testify effectively:"
            },
            {
              list: [
                {
                  text: "Know the key facts of the case.",
                  how: "Review your report and memorize key facts."
                },
                {
                  text: "Answer the question asked, but not more.",
                  how:
                    "Listen carefully to the question and pause before you answer."
                },
                {
                  text: "Admit mistakes, when appropriate.",
                  how:
                    "It's OK to say you made a mistake, the jury will appreciate your honesty."
                },
                {
                  text:
                    "If you are uncertain of an answer, ask for clarification.",
                  how:
                    "It's OK to ask the attorney to separate a compound question or repeat a question."
                }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "5e",
    title: "Plan what to wear",
    navOptions: [],
    content: [
      {
        text: "Plan what to wear",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text:
                "Your appearance can affect your credibility. If your agency has a policy about dressing for court, follow those guidelines. If not, here are some suggestions."
            },
            {
              list: [
                { text: "If you are on duty, testify in your uniform" },
                {
                  text:
                    "If you are off duty, testify in civilian business attire"
                },
                { text: "Limit accessories to essentials only" },
                { text: "Clothes should be clean and well pressed" },
                { text: "Shoes should be shined" }
              ]
            },
            {
              text: "Your overall appearance should be neat and clean"
            }
          ]
        }
      }
    ]
  },
  {
    id: "6a",
    title: "Remember your courthouse demeanor",
    navOptions: [],
    content: [
      {
        text: "How you conduct yourself is important",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text:
                "Maintain your professional demeanor at all times, even when you aren't on the witness stand. This includes in areas such as:"
            },
            {
              list: [
                { text: "Outside the courtroom" },
                { text: "Hallways during breaks" },
                { text: "Elevators" },
                { text: "Restrooms" },
                { text: "Coffee shops, etc." }
              ]
            },
            {
              text:
                "Less-than-professional conduct may be overheard or witnessed by jurors, attorneys, family members of involved parties, other witnesses, or the court bailiff. Individuals may think you (or the prosecution in general) do not take the case seriously, which can damage your credibility."
            }
          ]
        }
      }
    ]
  },
  {
    id: "6b",
    title: "Prepare while you wait",
    navOptions: [],
    content: [
      {
        text: "Use down time to prepare",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text: "While you wait to testify, you can: "
            },
            {
              list: [
                { text: "Review your report" },
                { text: "Memorize the basic facts of the case" },
                { text: "Review good witness behaviors" }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "6c",
    title: "Reduce stress",
    navOptions: [],
    content: [
      {
        text: "On the day of your testimony take time to relax",
        explanation: {
          text: "Why?",
          popOver: [
            {
              text:
                "Reducing stress should be an on-going goal but on the day of your testimony, be sure to take deep breaths and try to relax before you testify. Being mindful about your role to tell the truth and to help in the justice system process will help."
            }
          ]
        }
      }
    ]
  },
  {
    id: "7",
    title: "All testimony prep tips",
    navOptions: ["4a", "4b", "4c", "5a", "5b", "5c", "5e", "6a", "6b", "6c"]
  },
  {
    id: "notifications",
    title: "Notifications",
    navOptions: []
  }
];

export default data;
